import { createApiAction } from '@saucelabs/sl-util-redux';

import * as actions from './actions';
import * as types from './types';

export const initialize = createApiAction(
  types.INITIALIZE,
  (payload, meta, dispatch) => dispatch(actions.getSauceConnectDownloadLinks()),
);
